import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
} from "@chakra-ui/react";
import { CommunicationModalHeader } from "@src/components/widgets/Modals/ModalCommunication/CommunicationModalHeader";
import { COMMUNICATION_TABS } from "@src/constants/tasks";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import type { PropsWithChildren } from "react";
import { CommentInput } from ".";

interface DrawerWrapperProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DrawerWrapper = observer(function DrawerWrapper({
  children,
  isOpen,
  onClose,
}: PropsWithChildren<DrawerWrapperProps>) {
  const { taskDetailModalStore: store } = useStore();

  return (
    <Drawer
      // Keep false, otherwise emoji popovers wont be able to scroll
      blockScrollOnMount={false}
      isFullHeight
      isOpen={isOpen}
      onClose={onClose}
      placement="right"
      trapFocus={false}
    >
      <DrawerContent
        w={{
          base: "full",
          md: "900px",
          "1.5xl": "980px",
        }}
        maxW={{
          base: "full",
          md: "900px",
          "1.5xl": "980px",
        }}
        h="100dvh"
        borderColor="grey.100"
        borderLeftWidth="1px"
        shadow="2xl"
      >
        <CommunicationModalHeader
          onClose={onClose}
          onTimeTrackingItemCreated={(trackedTime) => {
            store.disclosureState.additionalData?.onTimeTrackingItemCreated?.(
              trackedTime,
            );
          }}
        />
        <DrawerBody ref={store.drawerBodyRef} overflowX="hidden" p="0">
          {children}
        </DrawerBody>
        {store.task.value?.id &&
          COMMUNICATION_TABS.includes(store.activeTabId.value) && (
            <DrawerFooter px="8" borderColor="grey.100" borderTopWidth="1px">
              <CommentInput taskId={store.task.value.id} />
            </DrawerFooter>
          )}
      </DrawerContent>
    </Drawer>
  );
});
